import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'
import { Employees } from 'modules/employees/store/collections/employees'

export const calendarEventEmployee = (calendarEvent: CalendarEvent, employees: Employees) => {
  const employeeId = calendarEvent.metadata('employee_id')

  return employees.get(employeeId)
}
